// extracted by mini-css-extract-plugin
export default {"root":"Header_root__w8BJz","rootFixed":"Header_rootFixed__ZTtal"};